/**
 * Store product IDs for all subscription plans, keyed by the internal plan id used
 * across the payments pages. Each platform's product id is the literal SKU registered
 * in that store (Play Console / App Store Connect) — no suffix derivation. A coupon's
 * `storePlanNamePostfix` (when discountType is 'discount') is appended to the resolved
 * platform id, matching the discounted SKU naming set up per-coupon in Firestore.
 */
export type PlanId =
  | 'month1'
  | '3months1'
  | 'yearly'
  | 'yamen1'
  | 'yamen3months1'
  | 'yamen1yearly1';

interface ProductIdEntry {
  android: string;
  ios: string;
}

export const PRODUCT_IDS: Record<PlanId, ProductIdEntry> = {
  month1: { android: 'month1', ios: 'month1apple2' },
  '3months1': { android: '3months1', ios: 'month3apple2' },
  yearly: { android: 'yearly', ios: 'year1apple2' },
  yamen1: { android: 'yamen1', ios: 'yamen1apple' },
  yamen3months1: { android: 'yamen3months1', ios: 'yamen3months1apple' },
  yamen1yearly1: { android: 'yamen1yearly1', ios: 'yamen1yearlyapple' },
};

// export const DISCOUNT_PRODUCT_IDS: Record<PlanId, ProductIdEntry> = {
//   month1: { android: 'month1', ios: 'month1apple2' },
//   '3months1': { android: '3months1', ios: 'month3apple2' },
//   yearly: { android: 'yearly', ios: 'year1apple2' },
//   yamen1: { android: 'yamen1', ios: 'yamen1apple' },
//   yamen3months1: { android: 'yamen3months1', ios: 'yamen3months1apple' },
//   yamen1yearly1: { android: 'yamen1yearly1', ios: 'yamen1yearlyapple' },
// };

/**
 * Resolves the final store product id to send to Flutter for a purchase.
 * Falls back to the raw planId for any id not present in the map, preserving
 * the previous ad-hoc behavior.
 */
export function resolveStoreProductId(
  planId: string,
  isIos: boolean,
  couponPostfix?: string,
): string {
  const entry = PRODUCT_IDS[planId as PlanId] as ProductIdEntry | undefined;
  const base = isIos ? (entry?.ios ?? planId) : (entry?.android ?? planId);
  return couponPostfix ? base + couponPostfix : base;
}
